import { render, staticRenderFns } from "./VendorAllocatedOrder.vue?vue&type=template&id=7c5e1120&"
import script from "./VendorAllocatedOrder.vue?vue&type=script&lang=js&"
export * from "./VendorAllocatedOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\270b-ariq\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c5e1120')) {
      api.createRecord('7c5e1120', component.options)
    } else {
      api.reload('7c5e1120', component.options)
    }
    module.hot.accept("./VendorAllocatedOrder.vue?vue&type=template&id=7c5e1120&", function () {
      api.rerender('7c5e1120', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vendors/VendorAllocatedOrder.vue"
export default component.exports